import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Attachment02 = function Attachment02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M17.5 5.2558V16.5c0 3.0376-2.4624 5.5-5.5 5.5s-5.5-2.4624-5.5-5.5V5.6667C6.5 3.6417 8.1416 2 10.1667 2c2.025 0 3.6666 1.6416 3.6666 3.6667v10.779c0 1.0126-.8208 1.8334-1.8333 1.8334s-1.8333-.8208-1.8333-1.8334V6.6512"
    })
  }));
};
export default Attachment02;